@let _cartData = cartData();

@if (!isMobile$) {
  <sd-dropdown
    [brand]="brand()"
    dropdownCustomId="dropdownCart"
    [iconSize]="isDevice$ ? iconSize.medium : iconSize.small"
    icon="icon-cart"
    [buttonIconTitle]="
      (totalProducts > 1) ? ('cart.minicart.a11y.myCartItems' | translate: {productNumber: totalProducts}) :
      (totalProducts === 1) ? ('cart.minicart.a11y.myCartItem' | translate: {productNumber: totalProducts}) :
      'cart.minicart.a11y.myCart' | translate
    "
    [buttonIconTitleHidden]="true"
    (isOpenedChange)="onOpenedChange($event)"
  >
    <ng-container sd-dropdown-menu>
      <div class="c__header">
        <sd-title customClass="brand--h5" class="c__title">
          {{ "cart.minicart.title" | translate }}
        </sd-title>
        @if (_cartData?.products?.length >= 2) {
          <button type="button" class="is-reset is-link" (click)="onEmptyCart()">
            <span>{{"cart.minicart.actions.empty" | translate}}</span>
          </button>
        }
      </div>
      <p class="c__products-number is-overline">
        {{ (totalProducts > 1) ?
          ("cart.minicart.productsNumber" | translate: { productNumber: totalProducts }) :
          ("cart.minicart.productNumber" | translate: { productNumber: totalProducts})
        }}
      </p>
      @if (_cartData?.products?.length) {
        <ul sd-list-block class="c__products-list">
          @for (product of _cartData.products; track $index) {
            <li tabindex="1" class="c__option">
              <sd-navigation-product-card
                [indexFollow]="product?.indexFollow !== undefined ? product.indexFollow : true"
                [productInfo]="product"
                [isReadOnly]="false"
                (quantity)="onQuantityChange(product.code, $event)"
                [quantityDisabled]="_cartData?.quantityDisabled"
                (openRecommendedPriceModal)="onOpenRecommendedPriceModal()"
                [isSimplified]="true"
              />
              <button sd-button-icon
                class="c__delete-product"
                [size]="iconSize.xs"
                [buttonIconTitle]="'cart.minicart.actions.delete' | translate"
                [titleHidden]="true"
                (click)="onDelete(product.code)"
                icon="icon-trash"
              ></button>
            </li>
          }
          <li>
            @if (_cartData?.promos?.length > 0) {
              <ul class="c__promos-list is-xs">
                @for (promo of _cartData.promos; track promo.promo) {
                  <li>
                    <sd-product-promo [promo]="promo" (learnMoreClick)="onPromoClick($event)" />
                  </li>
                }
              </ul>
            }
          </li>
        </ul>
        @if (_cartData?.totalPrice || _cartData?.shipping) {
          <footer>
            @if (_cartData?.totalPrice) {
              <div class="c__total">
                <span class="is-caption">{{ "cart.minicart.totalPrice" | translate }}</span>
                <span class="is-body-s is-semi-bold">
                  {{ _cartData.totalPrice }}
                  <sd-converted-price class="is-text-right is-block" [price]="_cartData.totalPrice" />
                </span>
              </div>
            }
            @if (_cartData?.shipping) {
              <div class="c__shipping">
                <span class="is-caption">{{ _cartData.shipping?.info }}</span>
                <span class="{{ _cartData?.isShippingFree ? 'is-promo-1' : '' }} is-body-s is-semi-bold">
                  {{ _cartData?.isShippingFree ? ('checkout.total.free' | translate) : _cartData.shipping?.cost }}
                </span>
              </div>
            }
            @if (_cartData?.paymentCost && !_cartData?.isPaymentFree) {
              <div class="c__shipping">
                <span class="is-caption">{{ "cart.minicart.paymentCost" | translate }}</span>
                <span class="is-body-s is-semi-bold">
                  {{ _cartData.paymentCost }}
                </span>
              </div>
            }
          </footer>
        }
      } @else {
        <p class="is-empty is-caption">{{ "cart.minicart.empty" | translate }}</p>
      }
      <div class="c__actions">
        @if (_cartData?.products) {
          <a sd-button
            class="c__basket"
            icon="icon-cart"
            (click)="closeDropdown()"
            [routerLink]="_cartData?.cartUrl"
          >
            <span>{{ "cart.minicart.actions.cart" | translate }}</span>
          </a>
          <a class="c__shop" role="button" (click)="closeDropdown()">
            <span>{{ "cart.minicart.actions.continue" | translate }}</span>
          </a>
        } @else {
          <a sd-button
            role="button"
            icon="icon-cart"
            (click)="closeDropdown()"
          >
            <span>{{ "cart.minicart.actions.continue" | translate }}</span>
          </a>
        }
      </div>
      @if (_cartData?.pushs?.length) {
        <div class="c__pushs-wrapper">
          @for (push of _cartData.pushs; track $index) {
            <sd-push-card
              [brand]="brand()"
              [indexFollow]="push?.indexFollow !== undefined ? push.indexFollow : true"
              [textConfig]="push.textConfig"
              [pushSize]="pushSizeEnum.xs"
              [mediaAsBackground]="push.mediaAsBackground"
              [push]="push.push"
              [mediaConfig]="push.mediaConfig"
              [isDescription]="push.isDescription"
              [titleLevel]="push.titleLevel"
              [imageRatio]="push.imageRatio"
              [themesConfig]="push.themesConfig"
            />
          }
        </div>
      }
    </ng-container>
  </sd-dropdown>
}

@if (isMobile$) {
  <sd-link
    [isIcon]="true"
    [buttonIconTitle]="(totalProducts > 1) ? ('cart.minicart.a11y.myCartItems' | translate: {productNumber: totalProducts}) : (totalProducts === 1) ? ('cart.minicart.a11y.myCartItem' | translate: {productNumber: totalProducts}) : 'cart.minicart.a11y.myCart' | translate"
    [titleHidden]="true"
    tabIndex="0"
    [size]="iconSize.medium"
    [link]=" {url: _cartData?.cartUrl }"
    icon="icon-cart"
  />
}

@if (totalProducts > 0) {
  <span class="c__product-number is-caption">
    {{ totalProducts }}
  </span>
}